var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.buttonHidden)?_c('button',{staticClass:"btn-showmore",attrs:{"id":"show-more-button"},on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(this.label))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }